module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/smile-icon.aad75095.svg";